import manager from "../Manager";

function ThankYouPreview({ data, index, inEditor, structures }) {
    return (
        <div className="tbcourse-template tbcourse-template-thankyou" key={index}>
            <div>
                <div className="tbcourse-template-thankyou-title">{data?.title ? data.title : structures.title?.placeholder}</div>
                <div className="tbcourse-template-thankyou-description" dangerouslySetInnerHTML={{ __html: data?.description ? data.description : manager.inEditor ? structures.description.placeholder : '' }}></div>
            </div>
        </div>
    )
}

export default ThankYouPreview;
